import { httpGet, httpPost } from '../../../../common/util'

export const getProductSet = (goodsId, pageNum, pageSize) => {
    return httpGet({
        url: '/activity/package/pageByGoodsId',
        data: {
            goodsId,
            pageNum,
            pageSize
        }
    })
}

export const orderProductSet = (activityType, activityId, skuVOs) => {
    return httpPost({
        url: '/order/preOrder',
        dataType: 'json',
        data: {
            activityType,
            activityId,
            skuVOs
        },
        auth: true
    })
}